<bpt-nav-bar [menuItems]="menuItems" [showMenuItem]="true" [expanded]="expanded" applicationName="eQMS"
    logo="eQMS-assets/nav-header-logo.png" collapseImage="eQMS-assets/collapse-ic.svg" [openMultiple]="true" titleText="Eurofins"
    subTitle="eQMS"></bpt-nav-bar>
